// Constant for Admin Internal Request

export const STATUS = {
  REQUESTED          : 'requested',
  DISPATCHED         : 'dispatched',
  ONGOING            : 'ongoing',
  MARKED_FOR_RETURN  : 'marked_for_return',
  PARTIALLY_RETURNED : 'partially_returned',
  RETURNED           : 'returned',
  COMPLETED          : 'completed',
  CANCELLED          : 'cancelled'
}

/** Internal Request status for new request */
export const REQUESTED_STATUS = {
  [STATUS.REQUESTED.toUpperCase()]  : STATUS.REQUESTED,
  [STATUS.DISPATCHED.toUpperCase()] : STATUS.DISPATCHED
}

/** Internal Request status for ongoing status */
export const ONGOING_STATUS = {
  [STATUS.ONGOING.toUpperCase()]            : STATUS.ONGOING,
  [STATUS.MARKED_FOR_RETURN.toUpperCase()]  : STATUS.MARKED_FOR_RETURN,
  [STATUS.PARTIALLY_RETURNED.toUpperCase()] : STATUS.PARTIALLY_RETURNED,
  [STATUS.RETURNED.toUpperCase()]           : STATUS.RETURNED
}

/** Internal Request status for ongoing status */
export const INBOUND_STATUS = {
  [STATUS.ONGOING.toUpperCase()]            : STATUS.ONGOING,
  [STATUS.MARKED_FOR_RETURN.toUpperCase()]  : STATUS.MARKED_FOR_RETURN,
  [STATUS.PARTIALLY_RETURNED.toUpperCase()] : STATUS.PARTIALLY_RETURNED,
  [STATUS.RETURNED.toUpperCase()]           : STATUS.RETURNED
}

/** Internal Request status for archive status */
export const ARCHIVE_STATUS = {
  [STATUS.COMPLETED.toUpperCase()] : STATUS.COMPLETED,
  [STATUS.CANCELLED.toUpperCase()] : STATUS.CANCELLED
}

export const PURPOSE = {
  PHOTOGRAPH : 'photograph',
  PHOTOSHOOT : 'photoshoot',
  BAZAAR     : 'bazaar',
  OTHER      : 'other'
}

export const CREATABLE_PURPOSE = {
  PHOTOSHOOT : PURPOSE.PHOTOSHOOT,
  BAZAAR     : PURPOSE.BAZAAR,
  OTHER      : PURPOSE.OTHER
}
